export default {
    o2oviewFormDetails: {
        Cancel: '取消订单',
        Confirm: '确认收货',
        Copy: '复制订单',
        Rejected: '已拒绝',
        Reason: '原因：',
        Reviewed: '审核人',
        Approval: '审核时间',
        Closed: '已关闭',
        Add: '添加标签',
        O2O: 'O2O信息',
        Pickup: '提货方式',
        store: '提货店铺',
        employee: '销售员工',
        Description: '说明',
        voucher: '消费凭证',
        Basic: '基础信息',
        Order: '订单类型',
        Third: '客户订单号',
        number: '内部订单号',
        Sales: '销售店铺',
        Three: '三方下单时间',
        creation: '内部创单时间',
        Buyer: '买家备注',
        Modify: '修改',
        Merchant: '商家备注',
        service: '客服备注',
        Receiving: '收货信息',
        nickname: '买家昵称',
        Consignee: '收货人',
        Phone: '手机',
        Address: '地址',
        Amount: '金额信息',
        Total: '商品总金额',
        payable: '买家应付总金额',
        cost: '成本总金额',
        Payment: '支付信息',
        method: '支付方式',
        Modistatusfy: '支付状态',
        time: '支付时间',
        actual: '买家实付金额',
        Yuan: '元',
        Invoice: '发票信息',
        View: '查看详情',
        type: '发票类型',
        header: '发票抬头',
        content: '发票内容',
        invoicing: '暂无开票申请',
        information: '订单信息',
        Product: '商品信息',
        you: '是否取消此订单，是否继续？',
        in: '操作中，是否继续？',
        only: '创建仅退款单',
        return: '创建退货单',
        refund: '创建退货退款单',
        want: '是否删除此标签？',
        error: '订单信息错误：orderInfoVO.innerOrderNo=',
        receive: '是否确认收货？',
    }
};
